import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },

    typography: {
      defaultFontFamily: "Cairo, sans-serif",
    },

    themes: {
      light: {
        primary: "#7986ca",
        secondry: "#44bee8",
      },
    },
  },
});
